module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9b72c9b4439a7f1c690add6b45c51360.png";